import React from "react";
import "./style/SocialGallery.css";

/**
 * Renders absolutely-positioned tag pins over the photo.
 * Shown on hover via CSS (.social-post-card__image-wrapper:hover .social-tag-overlay).
 *
 * Props:
 *   tags: SocialTagData[]  — each with {display_name, pos_x, pos_y}
 */
export default function SocialTagOverlay({ tags = [] }) {
  if (!tags.length) return null;

  return (
    <div className="social-tag-overlay">
      {tags
        .filter((t) => t.pos_x != null && t.pos_y != null)
        .map((tag) => (
          <div
            key={tag.social_tag_id}
            className="social-tag-pin"
            style={{
              left: `${tag.pos_x * 100}%`,
              top: `${tag.pos_y * 100}%`,
            }}
          >
            {tag.display_name}
          </div>
        ))}
    </div>
  );
}
